import type { UiTypes } from "various-ui";
import type { ModuleInfo, ModuleData } from "../index";
import { useOptions } from "./options";

export const useComposable = () => {
    //* 获取vue插件
    const route = useRoute();
    //* 配置项
    const options = useOptions();

    //* 响应式变量
    const refs = {
        //* 页面状态配置
        exist: ref<boolean>(true),
        loading: ref<boolean>(true),

        //* 页面数据
        data: ref<ModuleInfo[]>([]),
        page: ref<number>(1),
        count: ref<number>(0),
        sort: reactive({ key: "", value: "" }),

        //* 筛选项
        filters: ref<UiTypes.candidate[]>([]),
        classifications: ref<string[]>([]),
        classification: ref<boolean>(false),
    };

    //* 节点
    const nodes = {
        container: ref<HTMLDivElement>(),
    };

    //* 函数列表
    const methods = {
        //* 渲染函数
        render: (data: ModuleData) => {
            //* 数据初始化
            refs.filters.value = data.filters || [];
            refs.data.value = data.data || [];
            refs.page.value = data.page;
            refs.count.value = data.count;
            refs.loading.value = false;
        },

        //* 隐藏函数
        hidden: () => {
            refs.exist.value = false;
            refs.loading.value = false;
        },

        //* 数据获取
        acquire: (number?: number) => {
            //* 数据更新
            refs.loading.value = true;
            refs.page.value = number || refs.page.value;

            //* 排序初始化
            let sort = refs.sort.value == "desc" ? "-" : "";
            if (refs.sort.key == "HPO_rate") {
                sort += "frequency_order";
            } else if (refs.sort.key == "orphanet_rate") {
                sort += "orphanet_frequency_order";
            }

            //* 接口请求
            api.frontend(`/api/disease/characterization`, {
                finally: () => (refs.loading.value = false),
                method: "POST",
                data: {
                    id: route.params.id,
                    mode: "disease",
                    page: refs.page.value,
                    classify: refs.classifications.value,
                    sort: sort ? [sort] : [],
                },
                success: (response) => {
                    refs.data.value = response?.data || [];
                    refs.count.value = response?.count || 0;
                    //* 位置移动
                    if (nodes.container.value && scrollTo) {
                        scrollTo({ top: nodes.container.value.offsetTop - 200, behavior: "smooth" });
                    }
                },
            });
        },

        //* 排序函数
        sort: (data: { key: string; value: string }) => {
            //* 数据初始化
            refs.sort.key = data?.key || "";
            refs.sort.value = data?.value || "";
            //* 数据获取
            methods.acquire(1);
        },

        //* 选择回调
        classifications: () => {
            //* 数据更新
            refs.classification.value = refs.classifications.value.length == refs.filters.value.length;
            //* 数据获取
            methods.acquire(1);
        },

        //* 全选回调
        classification: () => {
            //* 数据更新
            if (refs.classification.value) {
                refs.classifications.value = [];
                refs.filters.value.forEach((value) => {
                    refs.classifications.value.push(value.value);
                });
            } else {
                refs.classifications.value = [];
            }

            //* 数据获取
            methods.acquire(1);
        },
    };

    return { refs, nodes, methods, options };
};
